import { MaterialService } from './material.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams, HttpContext } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Occurrence } from '../model/occurrence.model';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { Router } from '@angular/router';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { nextEvent } from '../model/event.model';

@Injectable()
export class UpcomingService extends KiwixiService {
  apiUpcoming = environment.server + 'upcomings/';
  apiUpcomingEvent = environment.server + 'events/next/';

  constructor(
    private _http: HttpClient,
    private httpClient: HttpClient,
    private _router: Router,
    kiwixiGlobals: KiwixiGlobals,
    private materialService: MaterialService,
  ) {
    super(_http, _router, kiwixiGlobals, materialService);
  }

  getUpcomings(params: HttpParams, context?: HttpContext) {
    const header = this.createHttpClientAuthorizationHeader();
    const options: any = {
      headers: header,
      params: params,
    };
    
    // Ajouter le contexte HTTP si fourni (pour SKIP_LOADING)
    if (context) {
      options.context = context;
    }
    
    return this._http.get(this.apiUpcoming, options)
      .pipe(
        catchError(this.handleErrorObservable('getUpcomings'))
      );
  }

  getUpcomingsWithUrl(_url): Observable<Occurrence[]> {
    const header = this.createHttpClientAuthorizationHeader();
    return this.httpClient.get<Occurrence[]>(_url, {
      headers: header
    }).
      pipe(
        catchError(this.handleErrorObservable<Occurrence[]>(`getUpcomings`))
      );
  }

  getUpcomingsNextEvent(params?): Observable<nextEvent> {
    const header = this.createHttpClientAuthorizationHeader();
    return this.httpClient.get<nextEvent>(this.apiUpcomingEvent + '?salt=' + Math.random().toString(), {
      headers: header,
      params: params
    }).
      pipe(
        catchError(this.handleErrorObservable<nextEvent>(`getUpcomings`))
      );
  }

  getUpcomingsNextOccurrence(_url, params: HttpParams): Observable<Occurrence[]> {
    const header = this.createHttpClientAuthorizationHeader();
    return this.httpClient.get<Occurrence[]>(_url, {
      headers: header,
      params: params
    }).
      pipe(
        catchError(this.handleErrorObservable<Occurrence[]>(`getUpcomings`))
      );
  }

  getUpcoming(id): Observable<Occurrence> {
    const urlUpcoming = this.apiUpcoming + id + '/';
    const header = this.createHttpClientAuthorizationHeader();
    return this.httpClient.get<Occurrence>(urlUpcoming, { headers: header }).
      pipe(
        catchError(this.handleErrorObservable<Occurrence>(`getUpcoming`))
      );
  }

  patchUpcoming(_url, param): Promise<Occurrence> {
    const headers = this.createHttpClientAuthorizationHeader();
    return this.httpClient.patch(_url, JSON.stringify(param), { headers: headers })
      .toPromise()
      .then((res: any) => res)
      .catch(error => {
        this.materialService.openSnackBar(`La mise à jour a échouée`, 'red');
        console.error('error Patch Upcoming', error);
      })
  }
}
